import React, { useContext, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Link } from 'react-router-dom';
import { Context } from '../..';
import styles from './HomePage.module.scss';  // Ensure correct path to styles

const HomePage: React.FC = () => {
  const { store } = useContext(Context);

  useEffect(() => {
    store.getCertifications();
    store.getApplications(); // Завантажити заявки кандидатів
  }, [store]);

  return (
    <div className={styles.home}>
      <div className={styles['home__header']}>
        <Link className={styles['home__title']} to="/certifications">Доступні сертифікації</Link>
      </div>
      <div className={styles['home__list']}>
        {store.certifications.slice(0, 6).map(cert => (
          <div key={cert.id} className={styles['home__item']}>
            <Link to={'/certifications/' + cert.id} className={styles['home__item-link']}>
              <h3 className={styles['home__item-title']}>{cert.name}</h3>
              <p className={styles['home__item-iso']}>ISO №{cert.ISO}</p>
              {cert.photo && (
                <img
                  src={`${process.env.REACT_APP_BASE_URL}/images/${cert.photo}`}
                  alt={cert.name}
                  className={styles['home__item-img']}
                />
              )}
            </Link>
          </div>
        ))}
        {store.certifications.length === 0 && <p className={styles['home__no-items']}>Сертифікації ще немає.</p>}
      </div>

      {store.user?.role === 'admin' && (
        <div className={styles['home__candidates']}>
          <h4><Link to="/admin/applications">Кандидати</Link></h4>
          <div className={styles['applications__list']}>
            {store.applications.map(application => (
              <Link to={`/admin/applications/${application.id}`} key={application.id} className={styles['applications__item']}>
                <p className={styles['applications__item-title']}>ISO №{application.certification.ISO} - {application.certification.name}</p>
                <p className={styles['applications__item-title']}>ПІБ: {application.full_name}</p>
                {application.certification.photo && (
                  <img src={`${process.env.REACT_APP_BASE_URL}/images/${application.certification.photo}`} alt={application.certification.name} className={styles['applications__item-img']} />
                )}
                <p className={styles['applications__item-description']}>{application.status}</p>
                <p className={styles['applications__item-date']}>Дата подачі: {new Date(application.createdAt).toLocaleDateString()}</p>
              </Link>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default observer(HomePage);
